"use strict";
exports.__esModule = true;
exports.LineHeights = exports.FontWeights = exports.FontSizes = exports.FontFamilies = void 0;
var FontFamilies;
(function (FontFamilies) {
    FontFamilies["QuincyCF"] = "QuincyCF";
    FontFamilies["Inter"] = "Inter";
    FontFamilies["National"] = "National";
    FontFamilies["Feature"] = "Feature";
    FontFamilies["IBMPlexMono"] = "IBMPlexMono";
})(FontFamilies = exports.FontFamilies || (exports.FontFamilies = {}));
var FontSizes;
(function (FontSizes) {
    FontSizes[FontSizes["fontSize8"] = 8] = "fontSize8";
    FontSizes[FontSizes["fontSize9"] = 9] = "fontSize9";
    FontSizes[FontSizes["fontSize10"] = 10] = "fontSize10";
    FontSizes[FontSizes["fontSize12"] = 12] = "fontSize12";
    FontSizes[FontSizes["fontSize14"] = 14] = "fontSize14";
    FontSizes[FontSizes["fontSize16"] = 16] = "fontSize16";
    FontSizes[FontSizes["fontSize17"] = 17] = "fontSize17";
    FontSizes[FontSizes["fontSize18"] = 18] = "fontSize18";
    FontSizes[FontSizes["fontSize20"] = 20] = "fontSize20";
    FontSizes[FontSizes["fontSize22"] = 22] = "fontSize22";
    FontSizes[FontSizes["fontSize24"] = 24] = "fontSize24";
    FontSizes[FontSizes["fontSize26"] = 26] = "fontSize26";
    FontSizes[FontSizes["fontSize28"] = 28] = "fontSize28";
    FontSizes[FontSizes["fontSize32"] = 32] = "fontSize32";
    FontSizes[FontSizes["fontSize40"] = 40] = "fontSize40";
    FontSizes[FontSizes["fontSize48"] = 48] = "fontSize48";
    FontSizes[FontSizes["fontSize56"] = 56] = "fontSize56";
    FontSizes[FontSizes["fontSize64"] = 64] = "fontSize64";
    FontSizes[FontSizes["fontSize72"] = 72] = "fontSize72";
    FontSizes[FontSizes["fontSize80"] = 80] = "fontSize80";
    FontSizes[FontSizes["fontSize96"] = 96] = "fontSize96";
    FontSizes[FontSizes["fontSize112"] = 112] = "fontSize112";
    FontSizes[FontSizes["fontSize140"] = 140] = "fontSize140";
})(FontSizes = exports.FontSizes || (exports.FontSizes = {}));
var FontWeights;
(function (FontWeights) {
    FontWeights[FontWeights["fontWeight400"] = 400] = "fontWeight400";
    FontWeights[FontWeights["fontWeight500"] = 500] = "fontWeight500";
    FontWeights[FontWeights["fontWeight600"] = 600] = "fontWeight600";
    FontWeights[FontWeights["fontWeight700"] = 700] = "fontWeight700";
    FontWeights[FontWeights["fontWeight800"] = 800] = "fontWeight800";
})(FontWeights = exports.FontWeights || (exports.FontWeights = {}));
var LineHeights;
(function (LineHeights) {
    LineHeights[LineHeights["lineHeight12"] = 12] = "lineHeight12";
    LineHeights[LineHeights["lineHeight16"] = 16] = "lineHeight16";
    LineHeights[LineHeights["lineHeight20"] = 20] = "lineHeight20";
    LineHeights[LineHeights["lineHeight24"] = 24] = "lineHeight24";
    LineHeights[LineHeights["lineHeight28"] = 28] = "lineHeight28";
    LineHeights[LineHeights["lineHeight32"] = 32] = "lineHeight32";
    LineHeights[LineHeights["lineHeight40"] = 40] = "lineHeight40";
    LineHeights[LineHeights["lineHeight48"] = 48] = "lineHeight48";
    LineHeights[LineHeights["lineHeight56"] = 56] = "lineHeight56";
    LineHeights[LineHeights["lineHeight64"] = 64] = "lineHeight64";
    LineHeights[LineHeights["lineHeight72"] = 72] = "lineHeight72";
    LineHeights[LineHeights["lineHeight80"] = 80] = "lineHeight80";
    LineHeights[LineHeights["lineHeight96"] = 96] = "lineHeight96";
    LineHeights[LineHeights["lineHeight112"] = 112] = "lineHeight112";
})(LineHeights = exports.LineHeights || (exports.LineHeights = {}));
